module.exports = __webpack_public_path__ + "img/we.8c9bf966.svg";